import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Z_INDEX } from '@liveHelper/constants'
import {
  ASPECT_RATIO_LANDSCAPE,
  ASPECT_RATIO_PORTRAIT,
  CHAT_CUSTOMER_VIDEO_HEIGHT,
} from '@oneToOne/shared/components/chat/constants'
import { FlexCenter, Transition } from '@oneToOne/shared/styles'

import { AgoraTrackPlayer } from '@core/agoraRTC'

const DesktopSizing = css`
  aspect-ratio: ${ASPECT_RATIO_LANDSCAPE};
  max-width: 100%;
  max-height: 100%;
`

export const OnCallVideoContainerWrapper = styled.div<{
  isMinimized: boolean
  isMobileWeb: boolean
  doesContainerSupportLandscape?: boolean
}>`
  position: absolute;
  overflow: hidden; // This is needed to have the video have rounded corners
  background: var(--gray-10);
  ${FlexCenter}

  ${({ isMinimized, isMobileWeb, doesContainerSupportLandscape }) =>
    isMinimized || isMobileWeb
      ? css`
          height: 100%;
          width: 100%;
          max-width: 100%;
          max-height: 100%;
        `
      : doesContainerSupportLandscape
        ? css`
            height: calc(100% - var(--spacing-16) - var(--spacing-16));
            ${DesktopSizing}
          `
        : css`
            width: calc(100% - var(--spacing-16) - var(--spacing-16));
            ${DesktopSizing}
          `}
  
    border-radius: ${({ isMinimized, isMobileWeb }) =>
      !isMinimized && !isMobileWeb ? 'var(--border-radius-md)' : 'inherit'};
`

export const CustomerAgoraTrackPlayer = styled(AgoraTrackPlayer)`
  position: relative;
  height: 100%;
  width: 100%;
  border-radius: var(--border-radius-md);
`

export const CustomerAgoraTrackPlayerWrapper = styled.div<{
  isMobilePortrait: boolean
  isCustomerVideoEnlarged: boolean
}>`
  ${Transition}
  position: absolute;
  top: var(--spacing-16);
  left: var(--spacing-16);
  border-radius: var(--border-radius-md);
  z-index: ${Z_INDEX.MAIN_VIDEO};
  height: ${({ isCustomerVideoEnlarged, isMobilePortrait }) => {
    const { portrait, landscape } = CHAT_CUSTOMER_VIDEO_HEIGHT
    if (isCustomerVideoEnlarged) {
      return isMobilePortrait ? portrait.expanded : landscape.expanded
    }
    return isMobilePortrait ? portrait.default : landscape.default
  }};

  aspect-ratio: ${({ isMobilePortrait }) =>
    isMobilePortrait
      ? `${ASPECT_RATIO_PORTRAIT}`
      : `${ASPECT_RATIO_LANDSCAPE}`};
  max-width: 80%;
  overflow: hidden;
  cursor: pointer;
`
